import * as React from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "./ui/tooltip";
import { CircularProgressBar } from "./ui/circular-progress-bar";

interface ChainProgressIndicatorProps {
  chainProgress: { current: number; total: number };
}

const ChainProgressIndicator: React.FC<ChainProgressIndicatorProps> = ({ chainProgress }) => (
  <Tooltip open={true}>
    <TooltipTrigger asChild>
      <div className="absolute -top-[72px] left-0.5 z-20">
        <CircularProgressBar
          progress={
            chainProgress.total > 0 ? (chainProgress.current / chainProgress.total) * 100 : 0
          }
          size={8}
          className="bg-neutral-white rounded-full shadow-sm border border-primary-200"
        >
          <span className="text-[10px] font-bold text-primary-300">{chainProgress.current}</span>
        </CircularProgressBar>
      </div>
    </TooltipTrigger>
    <TooltipContent side="top" align="start">
      <p className="text-[10px]">
        Action {chainProgress.current} of {chainProgress.total}
      </p>
    </TooltipContent>
  </Tooltip>
);

export { ChainProgressIndicator };
